import { render, staticRenderFns } from "./CN-N000098-24.vue?vue&type=template&id=5499a215&scoped=true"
import script from "./CN-N000098-24.vue?vue&type=script&lang=js"
export * from "./CN-N000098-24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5499a215",
  null
  
)

export default component.exports